import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerSuccessOptionsAppserviceService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetSelfRoles = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  query?: string
): UseQueryResult<Array<{ label: string; value: string }> | undefined, unknown> => {
  const companiesOptions = useQuery(
    ['getSelfRoles'],
    async () => {
      return await handleRequest(
        CustomerSuccessOptionsAppserviceService.getApiCustomerApiCustomerCustomerSuccessOptionsSelfRoles(
          query
        )
      );
    },
    {
      select(data) {
        return data?.map((company) => {
          return {
            label: company.name ?? '',
            value: company.id ?? '',
          };
        });
      },
    }
  );
  return companiesOptions;
};

export default useGetSelfRoles;
